import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import { mapSchema } from '@zaoblako/shared/modules/serde/schemas/map.schema';

import * as yup from 'yup';

/** Analytics for the previous three months for the budget request item */
export interface BudgetRequestItemAnalyticsInterface {
  /** Total amount value for all three months */
  totalAmount: number;
  /** Current plan amount (for adjustment requests only) */
  currentPlanAmount?: number;
  /** Account balance amount () */
  accountBalanceAmount?: number;
  /** Total amount value for each month (dictionary object where key is date in `YYYY-MM-DD` format and value is amount value) */
  monthAmount: Record<string, number>;
}

/** Analytics for the previous three months for the budget request item - DTO schema */
export const BudgetRequestItemAnalyticsDto = SerdeDtoClass.create<BudgetRequestItemAnalyticsInterface>(TaskDtoKeysEnum.BUDGET_REQUEST_ITEM_ANALYTICS_DTO, {
  totalAmount: {
    label: 'Общая сумма',
    serializer: yup.number(),
  },
  currentPlanAmount: {
    optional: true,
    label: 'Текущий план',
    serializer: yup.number(),
  },
  accountBalanceAmount: {
    optional: true,
    label: 'Остатки на счетах',
    serializer: yup.number(),
  },
  monthAmount: {
    label: 'Сумма по месяцам',
    serializer: mapSchema(
      yup.string(),
      yup.number(),
    ),
  },
});
